var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarCancellation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M9 1a1 1 0 1 0-2 0v5h2zm16 0a1 1 0 1 0-2 0v5h2zM2 29V12h23v-2H2V5a1 1 0 0 1 1-1h2V2H3a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3h-2v2h2a1 1 0 0 1 1 1v24a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1M21 4V2H11v2zm-2.172 12.707a1 1 0 1 1 1.415 1.414l-2.829 2.829 2.829 2.828a1 1 0 0 1-1.414 1.414L16 22.364l-2.828 2.828a1 1 0 1 1-1.415-1.414l2.829-2.828-2.828-2.829a1 1 0 0 1 1.414-1.414L16 19.535z",
  clipRule: "evenodd"
})));
export default SvgCalendarCancellation;